module.exports = __webpack_public_path__ + "static/media/4.af2f2a50.jpg";